import {saveFilters}  from "../reducers/DashboardFilters";

export const updateDashboardFilters = (items) => (dispatch) => {
    dispatch(saveFilters(items));
  };